module.exports = __webpack_public_path__ + "static/assets/dd2336934f716f53655b15101dc64689.svg";